<template>
  <div>
    <v-simple-table fixed-header>
      <template>
        <thead>
          <tr>
            <th class="text-center">発注ID</th>
            <th class="text-left">記事タイトル</th>
            <th class="text-left">ステータス</th>
            <th class="text-left">ライター名</th>
            <th class="text-center">類似度判定</th>
            <th class="text-center">一致度判定</th>
            <th class="text-center">取得日時</th>
            <th class="text-center">詳細</th>
            <th class="text-center">通過</th>
            <th class="text-center">差し戻し</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(inspection, index) in inspections" :key="inspection.id">
            <td class="text-center">{{ inspection.order.id }}</td>
            <td>{{ inspection.postTitle }}</td>
            <td>
              <v-chip
                x-small
                label
                :color="orderStatusColors[inspection.order.status]"
              >
                {{ orderI18ns.status[inspection.order.status] }}
              </v-chip>
            </td>
            <td>{{ inspection.userName }}</td>
            <td v-if="!inspection.ccdEndAt" class="text-center" colspan="2">
              <div
                v-if="inspection.status == 'detection_error'"
                class="caption"
              >
                <v-chip label small dark color="error" class="text-center"
                  >チェックエラー
                </v-chip>
              </div>
              <v-btn
                v-else-if="inspection.queueId"
                small
                @click="getCcdResult(inspection.id)"
                >結果を取得する</v-btn
              >
            </td>
            <td v-if="inspection.ccdEndAt">
              <v-chip
                Default
                tile
                id="similarity"
                :color="copyCheckLikeStatusColors[inspection.likeStatus]"
              >
                {{ inspection.likePercent }}%<br />
                {{ copyCheckLikeStatusMessage[inspection.likeStatus] }}
              </v-chip>
            </td>
            <td v-if="inspection.ccdEndAt">
              <v-chip
                Default
                tile
                id="similarity"
                :color="copyCheckMatchStatusColors[inspection.matchStatus]"
              >
                {{ inspection.matchPercent }}%<br />
                {{ copyCheckMatchStatusMessage[inspection.matchStatus] }}
              </v-chip>
            </td>
            <td>
              {{ inspection.ccdEndAt | moment }}
            </td>
            <td>
              <div
                v-if="inspection.status === 'detection_error'"
                class="caption"
              >
                {{ inspection.ccdErrorMessage }}
              </div>
              <v-btn
                v-if="inspection.queueId"
                link
                :href="
                  'https://text.ccd.tokyo/Result/detail?id=' +
                  inspection.queueId
                "
                small
                target="_blank"
              >
                <v-icon left small color="grey"> mdi-share </v-icon>
                確認
              </v-btn>
            </td>
            <td>
              <div
                v-if="
                  inspection.order.status === 'under_inspection'
                "
              >
                通過済み
              </div>
              <v-btn
                v-else-if="
                  inspection.status !== 'waiting_inspection' &&
                  inspection.status !== 'under_inspection' &&
                  !writerCompleted(inspection.status) &&
                  inspection.order.status !== 'writing' &&
                  isNewestInspection(inspection, index)
                "
                color="success"
                small
                @click="passDetection(inspection.id)"
                >通過</v-btn
              >
            </td>
            <td>
              <v-btn
                v-if="
                  !writerCompleted(inspection.status) &&
                  inspection.order.status == 'under_detection' &&
                  isNewestInspection(inspection, index)
                "
                small
                color="error"
                @click="remandOrder(inspection.id)"
                >差し戻し</v-btn
              >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import order_utils from '@/mixins/order_utils'
import snakecaseKeys from 'snakecase-keys'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  mixins: [order_utils],
  props: {
    inspections: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      orderStatusColors: {
        not_applied: '',
        writing: 'primary',
        under_detection: 'warning',
        under_inspection: 'warning',
        under_client_inspection: 'warning',
        completed: 'success'
      },
      copyCheckLikeStatusColors: {
        like_success: 'success',
        like_warning: 'warning',
        like_error: 'danger'
      },
      copyCheckMatchStatusColors: {
        match_success: 'success',
        match_warning: 'warning',
        match_error: 'danger'
      },
      copyCheckLikeStatusMessage: {
        like_success: '良好',
        like_warning: '要注意',
        like_error: 'コピーの疑い'
      },
      copyCheckMatchStatusMessage: {
        match_success: '良好',
        match_warning: '要注意',
        match_error: 'コピーの疑い'
      }
    }
  },
  computed: {
    ...mapState({
      orderI18ns: (state) => snakecaseKeys(state.I18n.enums.order)
    })
  },
  methods: {
    getCcdResult (inspectionId) {
      this.$emit('getCcdResult', inspectionId)
    },
    remandOrder (inspectionId) {
      this.$emit('remandOrder', inspectionId)
    },
    passDetection (inspectionId) {
      this.$emit('passDetection', inspectionId)
    },
    isNewestInspection (inspection, index) {
      // 一番上の行じゃない
      if (index > 0) {
        // 自分より手前の要素の中に同じorder_idを持っている場合にボタンを表示しない
        for (let i = index; i > 0; i--) {
          if (this.inspections[i - 1].orderId == inspection.orderId) {
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
#similarity {
  display: block;
  text-align: center;
  color: #fff;
  height: 100%;
  font-size: 0.8rem;
  white-space: normal;
  border-radius: 0;
}
</style>
